import { useEffect, useState } from 'react';
import { softphone, SoftphoneSnapshot } from './streams';

export function useSoftphone(): SoftphoneSnapshot {
  const [snap, setSnap] = useState<SoftphoneSnapshot>({ agentStatus: 'init', agentName: '', call: null });
  useEffect(() => {
    const container = document.getElementById('ccp-container');
    if (container) softphone.init(container);
    const unsub = softphone.subscribe(setSnap);
    return () => { unsub(); };
  }, []);
  return snap;
}
